<template>
    <div class="bt-dash">
        <div class="row p-0">
            <div class="col-12">
                <div class=" custom-scrollbar" style="height: 35dvh; overflow-y: auto;">
                    <table class="w-100 table table-fixed">
                        <thead class=" bg-white">
                            <tr>
                                <th class="align-middle">{{ t('Label') }}</th>
                                <th class="align-middle">{{ t('Preset Item') }}</th>
                                <th class="align-middle">{{ t('Qty') }}</th>
                                <th class="align-middle">{{ t('Price') }}</th>
                                <th class="align-middle">{{ t('Group') }}</th>
                                <th class="align-middle">{{ t('Allow Reduction') }}</th>
                                <th>
                                    <button class="btn btn-primary px-2" type="button" @click="" data-bs-toggle="modal"
                                        data-original-title="test" data-bs-target="#product-add-set-modal"
                                        style="width: 128px;">
                                        {{ t('Add Set Item') }}
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in compState.setItems" :key="item.id"
                                class="hover-shadow hover-pointer"
                                :class="{ active: compState.activeSelectedItem.id === item.id }"
                                @click="onSetItemClick(item)">
                                <td>{{ item.label }}</td>
                                <td class=" f-w-700">{{ item.presetItem?.basic?.name || 'N/A' }}</td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ item.basePrice }}</td>
                                <td class=" f-w-700">{{ item.linkGroup?.name || 'N/A' }}</td>
                                <td><i :class="item.allowReduction ? 'fa fa-check' : 'fa fa-times'"></i></td>
                                <td>
                                    <button class="btn btn-danger px-2" type="button"
                                        @click.stop="onRemoveSetItem(index)" style="width: 128px;">
                                        <i class="fa fa-times"></i> {{ t('Remove') }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="compState?.activeSelectedItem?.id" class="col-12 mt-3">
                <div class=" box-list-container bg-white rounded p-3 card">
                    <div style="grid-column: span 6 / span 6;">
                        <label>{{ t('Label') }}</label>
                        <input type="text" class="form-control" v-model="compState.activeSelectedItem.label" />
                    </div>
                    <div style="grid-column: span 3 / span 3;">
                        <label>{{ t('Base Price') }}</label>
                        <input type="number" class="form-control" v-model="compState.activeSelectedItem.basePrice" />
                    </div>
                    <div style="grid-column: span 3 / span 3;">
                        <label>{{ t('Qty') }}</label>
                        <input type="number" class="form-control" v-model="compState.activeSelectedItem.quantity" />
                    </div>
                    <div style="grid-column: span 6 / span 6;">
                        <div class="d-flex align-items-center gap-2 form-check checkbox-checked">
                            <input type="checkbox" :id="`checkbox-allow-reduction`" class="form-check-input"
                                v-model="compState.activeSelectedItem.allowReduction" />
                            <label :for="`checkbox-allow-reduction`" style="margin-top: 12px;">{{ t('Allow Reduction') }}</label>
                        </div>
                    </div>
                    <div style="grid-column: span 3 / span 3;">
                        <button class="btn btn-primary px-2" type="button" style="width: 100%;" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#product-search-modal">{{ t('Preset Item') }}
                        </button>
                    </div>
                    <div style="grid-column: span 3 / span 3;">
                        <button class="btn btn-secondary px-2" type="button" @click="" style="width: 100%;"
                            data-bs-toggle="modal" data-original-title="test"
                            data-bs-target="#product-group-search-modal">{{ t('Product Group') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <productAddSetItemModal @onSave="onAddSetItem" />
    <productSearchModal @onSelect="onSelectedProduct" />
    <productGroupSearchModal @onSelect="onSelectedGroup" />
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, reactive, watch, defineAsyncComponent } from 'vue';
import { useProductsStore } from '@/store/management/productsStore';
import type { LinkGroups, Product, SetItems } from '@/store/management/productsStore';
import { addSetItemAPI } from '@/utils/api';
import { viviposToSetitem, setItemToVivipos } from '@/store/management/productsStore';
import Swal from 'sweetalert2';

import { useI18n } from 'vue-i18n'
import { productsLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productsLanguage
})

const productAddSetItemModal = defineAsyncComponent(() => import('./productAddSetItemModal.vue'));
const productGroupSearchModal = defineAsyncComponent(() => import('./productGroupSearchModal.vue'));
const productSearchModal = defineAsyncComponent(() => import('./productSearchModal.vue'));

const productStore = useProductsStore();

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const compState = reactive({
    setItems: [] as SetItems[],
    activeSelectedItem: {} as SetItems
})

const onAddSetItem = (setItems: SetItems) => {
    compState.setItems.push(setItems);
    compState.activeSelectedItem = setItems;
};

const onRemoveSetItem = (index: number) => {
    compState.setItems.splice(index, 1);
    compState.activeSelectedItem = {} as SetItems;
}

const onSetItemClick = (item: SetItems) => {
    compState.activeSelectedItem = item;
}

const onSelectedProduct = (product: Product) => {
    compState.activeSelectedItem.presetItem = product;
    // if (activeProduct.value.basic.productNumber === product.basic.productNumber) {
    //     Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: 'Cannot select the same product as preset item',
    //     });
    //     return;
    // } else {
    //     compState.activeSelectedItem.presetItem = product;
    // }

}

const onSelectedGroup = (group: LinkGroups) => {
    compState.activeSelectedItem.linkGroup = group;

}

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const setItemsData = productGroup.setItems
        compState.setItems = setItemsData
    }
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const setItemsData = productGroup.setItems
        compState.setItems = setItemsData
    }
}, { immediate: true });

watch(compState, (newVal) => {
    console.log('newVal',newVal);

    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        setItems: newVal.setItems
    })
}, { deep: true });
</script>

<style scoped lang="scss">
.table-fixed thead {
    position: sticky;
    top: 0;
    /* Match your table background color */
    z-index: 1;
    /* Ensure the header stays on top */
}

table {
    background-color: white;
}

.box-list-container {
    grid-template-columns: repeat(12, minmax(0, 1fr));
}
</style>